import React from 'react';
import { useTranslation } from 'react-i18next';

import LabeledInput from '../LabeledInput';
import { SelectInput } from '../SelectInput';

import * as api from '../../api';

import defaultStyles from '../../styles/formSetStyles.module.css';
import { formatString } from '../utils';
import { isEnumMember } from 'common/dist/utils/types';

interface Props {
  associatedEntity: string;
  primaryEntity?: string;
  relationshipOptions: api.PracticePreference.RelationshipPreference;
  value: api.Common.Relationship | null;
  onChange: (relationship: api.Common.Relationship) => void;
  mainLabel?: string | null;
  subLabel?: string;
}

const RelationshipPicker: React.FC<Props> = ({
  relationshipOptions,
  mainLabel,
  subLabel,
  onChange,
  value,
  associatedEntity,
  primaryEntity = 'the patient',
}) => {
  const { t } = useTranslation();
  const entity1 = relationshipOptions.isReverseRelationship
    ? associatedEntity
    : t(primaryEntity);
  const entity2 = relationshipOptions.isReverseRelationship
    ? t(primaryEntity)
    : associatedEntity;

  const mainLabelString =
    mainLabel || mainLabel === null
      ? mainLabel
      : t('relationshipMainLabel', { entity1, entity2 });

  const subLabelString = subLabel
    ? t(subLabel)
    : t('relationshipSubLabel', {
        entity: entity1!.charAt(0).toLocaleUpperCase() + entity1!.slice(1),
      });

  return (
    <>
      {mainLabelString !== null && (
        <label
          htmlFor={`guarantor-relationship-question`}
          className={defaultStyles.Label}
        >
          {formatString(mainLabelString)}
        </label>
      )}
      <LabeledInput label={subLabelString} htmlFor="guarantor-relationship">
        <SelectInput
          id="guarantor-relationship"
          onChange={(relationshipString) => {
            if (!isEnumMember(api.Common.Relationship, relationshipString)) {
              return;
            }
            onChange(relationshipString);
          }}
          options={relationshipOptions.relationships
            .filter(
              (relationship) => relationship !== api.Common.Relationship.Self,
            )
            .map((relationship) => ({
              display: api.Previsit.relationshipOptionsMap[relationship],
              key: relationship,
              value: relationship,
            }))}
          value={value ?? ''}
        />
      </LabeledInput>
    </>
  );
};

export default RelationshipPicker;
